import { useEffect, useState } from "react";
import { useI18n } from "../i18n.jsx";
import PlusUpgradeModal from "./PlusUpgradeModal.jsx";

const WHATS_NEW_STORAGE_KEY = "sielpa:whats-new-plus-2026-05";

function hasSeenNotice() {
  try {
    return window.localStorage.getItem(WHATS_NEW_STORAGE_KEY) === "seen";
  } catch {
    return false;
  }
}

function markNoticeSeen() {
  try {
    window.localStorage.setItem(WHATS_NEW_STORAGE_KEY, "seen");
  } catch {
    // Keep the dismissal in memory when storage is unavailable.
  }
}

export default function WhatsNewNotice() {
  const { locale, setLocale, t } = useI18n();
  const [open, setOpen] = useState(() => !hasSeenNotice());
  const [plusModalOpen, setPlusModalOpen] = useState(false);

  function dismiss() {
    markNoticeSeen();
    setOpen(false);
  }

  function viewPlus() {
    dismiss();
    setPlusModalOpen(true);
  }

  useEffect(() => {
    if (!open) return undefined;

    function handleKeydown(event) {
      if (event.key === "Escape") dismiss();
    }

    window.addEventListener("keydown", handleKeydown);
    return () => window.removeEventListener("keydown", handleKeydown);
  }, [open]);

  const nextLocale = locale === "ja" ? "en" : "ja";
  const nextLocaleLabel = nextLocale === "ja" ? t("locale.japanese") : t("locale.english");
  const nextLocaleAria = nextLocale === "ja" ? t("locale.switchToJapanese") : t("locale.switchToEnglish");

  return (
    <>
      {open ? (
        <div className="plus-upgrade-backdrop" role="presentation" onMouseDown={dismiss}>
          <section
            className="plus-upgrade-dialog whats-new-dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby="whats-new-title"
            onMouseDown={(event) => event.stopPropagation()}
          >
            <button className="whats-new-close" type="button" aria-label={t("common.close")} onClick={dismiss}>
              x
            </button>
            <p className="kicker">{t("whatsNew.eyebrow")}</p>
            <h2 id="whats-new-title">{t("whatsNew.title")}</h2>
            <p>{t("whatsNew.languageCopy")}</p>
            <div className="whats-new-plus-copy">
              <h3>{t("whatsNew.plusTitle")}</h3>
              <p>{t("whatsNew.plusCopy")}</p>
              <p className="whats-new-optional-copy">{t("whatsNew.optionalCopy")}</p>
              <ul className="plus-upgrade-feature-list">
                <li>{t("whatsNew.featureVocabBurst")}</li>
                <li>{t("whatsNew.featurePremiumVoice")}</li>
                <li>{t("whatsNew.featureNoAds")}</li>
              </ul>
            </div>
            <div className="plus-upgrade-actions whats-new-actions">
              <button className="secondary-button" type="button" aria-label={nextLocaleAria} onClick={() => setLocale(nextLocale)}>
                {nextLocaleLabel}
              </button>
              <button className="secondary-button" type="button" onClick={dismiss}>
                {t("whatsNew.later")}
              </button>
              <button className="primary-button" type="button" onClick={viewPlus}>
                {t("whatsNew.viewPlus")}
              </button>
            </div>
          </section>
        </div>
      ) : null}
      <PlusUpgradeModal open={plusModalOpen} onClose={() => setPlusModalOpen(false)} source="whats-new-plus" />
    </>
  );
}
